<template>
  <nav
    v-if="isMenuVisible"
    ref="menuRef"
    class="fixed top-0 z-10 flex h-full min-h-dvh w-full flex-col justify-between gap-20 overflow-y-auto overflow-x-hidden pb-20 pt-20 lg:pb-[104px] lg:pt-30"
    aria-label="Main Menu"
    data-lenis-prevent
  >
    <div>
      <MenuListItem
        v-for="(link, index) in parents"
        :key="index"
        class="relative whitespace-nowrap"
        :data="link"
        :index="index"
      />
    </div>
    <div class="container grid-default text-black">
      <div class="col-span-full uppercase lg:col-span-5 lg:py-8">
        <SocialLinks :data="store.allSocialLinks" class="mb-10 lg:hidden" />

        <p>
          Pakt Media is a film & TV production company specialized in servicing high-end productions
          in the Alpe-Adria region.
        </p>
        <div class="mt-8 flex justify-between gap-4 lg:mt-12">
          <div class="flex flex-col gap-6">
            <span>Croatia</span>
            <address class="flex flex-col not-italic">
              <span>Savska cesta 118</span><span>10000 Zagreb</span><span>Croatia</span>
            </address>
          </div>
          <div class="flex flex-col gap-6">
            <span>Slovenia</span>
            <address class="flex flex-col not-italic">
              <span>Prešernov trg 1</span><span>1000 Ljubljana</span><span>Slovenia</span>
            </address>
          </div>
        </div>
      </div>
      <div class="col-span-full lg:col-span-4 lg:col-start-9 lg:self-end">
        <SocialLinks :data="store.allSocialLinks" class="hidden lg:flex" />
        <div
          class="-mb-[5%] -ml-2 whitespace-nowrap pt-5 text-[17.4vw] font-light uppercase leading-none lg:-mb-[5%] lg:ml-0 lg:mt-10 lg:text-[4.5vw]"
        >
          Pakt Media
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'
import { theme } from '#tailwind-config'
import type { MenuItemRecord } from '~/types/datocms'

const store = useAppStore()

const menuRef = ref<HTMLElement | null>(null)
const isMenuVisible = useState('menu')
const { menuHide } = useMenu()
const breakpoints = useBreakpoints(theme.screens)
const isScreenLg = breakpoints.greater('lg')
const { y } = useScroll(menuRef)
const mixBlendActive = useState('mixBlend', () => false)

watch(y, () => {
  if (y.value > 40) {
    mixBlendActive.value = true
  } else {
    mixBlendActive.value = false
  }
})

const props = defineProps({
  data: {
    type: Array as PropType<MenuItemRecord[]>,
    default: () => []
  }
})

// Filter top level items
const parents = computed(() => props.data.filter((item) => item.parent === null))

// Handle window resize if menu is visible
const handleResize = useDebounceFn(() => {
  if (isScreenLg.value && isMenuVisible.value) {
    menuHide()
  }
}, 400)

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>
